import { render, staticRenderFns } from "./choose-tagCode.vue?vue&type=template&id=0fb7ea82&scoped=true"
import script from "./choose-tagCode.vue?vue&type=script&lang=js"
export * from "./choose-tagCode.vue?vue&type=script&lang=js"
import style0 from "./choose-tagCode.vue?vue&type=style&index=0&id=0fb7ea82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7ea82",
  null
  
)

export default component.exports